<!--
 * @FileDescription: 订单退款页面-Mobile
 * @Author: 陈文景
 * @Date: 2022-11-07 09:42:30
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="container">
    <div class="back">
      <i class="el-icon-arrow-left" @click="goBack" />
      {{ $t('Order.Refund.Mobile.Index.Rufund') }}
    </div>

    <!-- <div v-if="other.refunded === 1" class="record"> -->
    <div v-if="other.refunded === 0" class="record">
      <div class="left">
        <span class="tips">{{ $t('Order.Refund.Mobile.Index.Tips1') }}</span>
        <span class="history" @click="seeRefundHistory">{{ $t('Order.Refund.Mobile.Index.ViewRefundHistory') }}</span>
      </div>
      <i class="el-icon-arrow-right right-icon" />
    </div>

    <div class="reason-remarks">
      <div class="reason" @click="onClickReason">
        <span :class="['tips', { active: form.refundReason || form.refundReason === 0 ? true : false }]">{{ reason(form.refundReason) }}</span>
        <i class="el-icon-arrow-right right-icon" />
      </div>

      <van-field v-model="form.remark" :disabled="!unshippeds.length" rows="2" autosize type="textarea" maxlength="120" placeholder="Remarks" show-word-limit />
    </div>

    <div v-loading="detailsLoading" class="goods-list">
      <!-- 未发货 -->
      <template v-if="unshippeds.length">
        <NotShippedGoods :data="unshippeds" @change="handleSelectAll" @amount="getCheckedAmountItem" />
      </template>

      <!-- 空状态 -->
      <template v-else>
        <div class="not-data">
          <img src="~@/assets/img/undraw_random_thoughts_re_cob6.svg" alt="img.svg" />
          <span class="tips-text">{{ $t('Order.Refund.Mobile.Index.NoRecord') }}</span>
        </div>
      </template>
    </div>

    <div v-loading="amountLoading" class="refunded-details">
      <h3>{{ $t('Order.Refund.Mobile.Index.RefundedAmount') }}</h3>
      <div class="amount-info">
        <p class="item">
          <span class="label">{{ $t('Order.Refund.Mobile.Index.Subtotal') }}</span>
          <span class="value">US ${{ amountTips(other.itemSubtotal) }}</span>
        </p>
        <p class="item">
          <span class="label">{{ $t('Order.Refund.Mobile.Index.ShippingFee') }}</span>
          <span class="value">US ${{ amountTips(other.shippingSubtotal) }}</span>
        </p>
        <p class="item">
          <span class="label">{{ $t('Order.Refund.Mobile.Index.PromoCode') }}</span>
          <span class="value">- US ${{ amountTips(other.promotion) }}</span>
        </p>
        <p class="item">
          <span class="label">{{ $t('Order.Refund.Mobile.Index.Coupon') }}</span>
          <span class="value">- US ${{ amountTips(other.coupon) }}</span>
        </p>
        <p class="item border">
          <span class="label">{{ $t('Order.Refund.Mobile.Index.Total') }}</span>
          <span class="value strong">- US ${{ amountTips(other.orderMaximumRefund) }}</span>
        </p>
      </div>
    </div>

    <div class="refunded-button">
      <VanButton :block="true" :disabled="!unshippeds.length" color="#99C41C" class="van-button" @click="submitApplicationForRefund">{{ $t('Order.Refund.Mobile.Index.Refund') }}</VanButton>
    </div>

    <van-popup v-model="showPicker" round position="bottom">
      <van-picker show-toolbar :columns="columns" @cancel="cancelRefundReason" @confirm="selectRefundReason" />
    </van-popup>

    <!-- 退款失败对话框 -->
    <RefundFaliDialog ref="refundFaliDialog" />
  </div>
</template>

<script>
import API from '@/api'

import VanButton from 'vant/lib/button'
import 'vant/lib/button/style'

import VanField from 'vant/lib/field'
import 'vant/lib/field/style'
import VanPopup from 'vant/lib/popup'
import 'vant/lib/popup/style'
import VanPicker from 'vant/lib/picker'
import 'vant/lib/picker/style'
import VanToast from 'vant/lib/toast'
import 'vant/lib/toast/style'

import NotShippedGoods from './components/NotShippedGoods.vue'
import RefundFaliDialog from './components/RefundFaliDialog.vue'

let form = {
  packItems: [
    // {
    //   kkItemId: undefined, // 商品ID
    //   skuCode: undefined, // 公司SKU
    //   productNum: undefined, // 商品数量
    //   packId: undefined // 包裹ID(未发货包裹不需要传)
    // }
  ], // 已发货
  refundReason: undefined, // 退款原因
  remark: undefined, // 备注
  refundAmount: 0, // 退款文本框(金额格式)
  isNotice: 0, // 0.不通知 1.通知 (是否邮箱通知客户)
  selectAllied: undefined // 针对未发货包裹 - 是否全选(0.未全选 1.全选)
}

let getAmountQuery = {
  items: [
    // {
    //   kkItemId: undefined,
    //   skuCode: undefined,
    //   productNum: 0
    // }
  ]
}

export default {
  components: {
    VanField,
    VanPopup,
    VanPicker,
    VanButton,
    NotShippedGoods,
    RefundFaliDialog
  },
  data() {
    return {
      selectAll: true,

      detailsLoading: false,
      amountLoading: false,

      form: { ...form }, // 创建售后单请求参数

      getAmountQuery: { ...getAmountQuery }, // 获取退款金额请求参数

      showPicker: false, // 是否显示退款原因选择器
      columns: [`${this.$t('Order.Refund.Mobile.Index.OutOfStock')}`, `${this.$t('Order.Refund.Mobile.Index.ShipmentDelay')}`, `${this.$t('Order.Refund.Mobile.Index.DonTWantAnymore')}`, `${this.$t('Order.Refund.Mobile.Index.IncorrectAddressInformation')}`, `${this.$t('Order.Refund.Mobile.Index.ProductSelectionErrorMultipleSelection')}`, `${this.$t('Order.Refund.Mobile.Index.Other')}`], // 取消原因选项
      // 取消原因下拉选项
      cancelReasonOptions: [
        { label: `${this.$t('Order.Refund.Mobile.Index.OutOfStock')}`, value: 3 },
        { label: `${this.$t('Order.Refund.Mobile.Index.ShipmentDelay')}`, value: 4 },
        { label: `${this.$t('Order.Refund.Mobile.Index.DonTWantAnymore')}`, value: 0 },
        { label: `${this.$t('Order.Refund.Mobile.Index.IncorrectAddressInformation')}`, value: 2 },
        { label: `${this.$t('Order.Refund.Mobile.Index.ProductSelectionErrorMultipleSelection')}`, value: 1 },
        { label: `${this.$t('Order.Refund.Mobile.Index.Other')}`, value: 5 }
      ],

      // Refunded Amount
      other: {
        refunded: 0, // 是否有退款记录(0.没有退款记录 1.有退款记录)
        orderMaximumRefund: 0, // 最大退款金额
        itemSubtotal: 0, // Item Subtotal
        shippingSubtotal: 0, // Shipping Subtotal
        promotion: 0, // Promo code
        coupon: 0 // Coupon
      },

      // 未发货商品
      unshippeds: []
    }
  },
  computed: {
    reason() {
      return (value) => {
        let reason
        if (value || value === 0) {
          this.cancelReasonOptions.forEach((item) => {
            if (item.value === value) {
              reason = item.label
            }
          })
        } else {
          reason = `${this.$t('Order.Refund.Mobile.Index.RefundReason')}`
        }
        return reason
      }
    },
    amountTips() {
      return (value) => value || 0
    }
  },
  created() {
    this.getRefundOrderInformation()
  },
  methods: {
    /**
     * API 获取可申请退款商品列表
     */
    async getRefundOrderInformation() {
      try {
        this.detailsLoading = true
        let { data } = await API.getRefundOrderInformation(this.$route.query.kakaOrderId)
        if (data) {
          this.other.refunded = data.refunded // 是否有退款记录(0.没有退款记录 1.有退款记录)
          this.unshippeds = this.reformUnshippeds(data.items || []) // 未发货
        }
        this.detailsLoading = false
      } catch (error) {
        this.detailsLoading = false
        throw new Error(error.message)
      }
    },

    /**
     * API 创建售后单
     */
    async createAfterSalesOrder() {
      try {
        let { code, data } = await API.createAfterSalesOrder(this.$route.query.kakaOrderId, this.form)
        if (code === 10000) {
          this.$router.push(`/order/success?returnsId=${data}`)
        } else {
          this.$refs.refundFaliDialog.show()
        }
      } catch (error) {
        this.$refs.refundFaliDialog.show()
      }
    },

    /**
     * API 获取退款金额
     */
    async getRefundOrderAmount() {
      try {
        this.amountLoading = true
        let { data } = await API.getRefundOrderAmount(this.$route.query.kakaOrderId, this.getAmountQuery)
        this.other.itemSubtotal = data.skusAmount
        this.other.shippingSubtotal = data.freightAmount
        this.other.promotion = data.promotionAmount // 优惠码金额
        this.other.coupon = data.couponTicketAmount // 优惠券金额
        this.form.refundAmount = data.totalAmount // 可退款金额总数
        this.other.orderMaximumRefund = data.totalAmount // 可退款金额总数
        this.amountLoading = false
      } catch (error) {
        this.amountLoading = false
      }
    },

    /**
     * 改造未发货列表数据
     *
     * @param {Array} unshippeds 未发货列表
     * @returns {Array} 改造后的数据
     */
    reformUnshippeds(unshippeds) {
      if (unshippeds.length) {
        return unshippeds.map((item) => ({
          ...item,
          options:
            JSON.parse(item.options) &&
            JSON.parse(item.options)
              .map((option) => JSON.parse(option).value)
              .join('、'),
          check: false, // 是否选中
          quantity: 0 // 退款商品数量
        }))
      } else {
        return unshippeds
      }
    },

    /**
     * 获取需要计算退款金额的商品
     */
    getCheckedAmountItem() {
      this.getAmountQuery.items = []
      // 未发货
      this.unshippeds.forEach((item) => {
        if (item.check) {
          this.getAmountQuery.items.push({
            kkItemId: item.kkItemId, // 商品ID
            skuCode: item.skuCode, // 公司SKU
            countryCode: item.countryCode, // 商品仓库国家编码
            productNum: item.quantity // 商品数量
          })
        }
      })
      // 调用获取退款金额的接口
      this.getRefundOrderAmount()
    },

    /**
     * 查看退款历史记录
     */
    seeRefundHistory() {
      this.$router.push(`/order/record?kakaOrderId=${this.$route.query.kakaOrderId}`)
    },

    /**
     * 点击退款原因
     */
    onClickReason() {
      if (this.unshippeds.length) {
        this.showPicker = true
      }
    },

    /**
     * 选择退款原因的回调事件
     */
    selectRefundReason(value) {
      this.cancelReasonOptions.forEach((item) => {
        if (item.label === value) {
          this.form.refundReason = item.value
        }
      })
      this.showPicker = false
    },

    /**
     * 关闭退款原因
     */
    cancelRefundReason() {
      this.showPicker = false
    },

    /**
     * 选中所有
     *
     * @param {Boolean} value 是否选中
     * @param {Number} type 1.已发货 2.未发货
     * @param {String} packId 包裹ID（操作已发货的包裹时则存在）
     */
    handleSelectAll(value, type, packId) {
      if (type === 2) {
        this.unshippeds.forEach((item) => {
          item.check = value
          item.quantity = value ? item.productNum : 0
        })
      }
      this.getCheckedAmountItem()
    },

    /**
     * 返回
     */
    goBack() {
      this.$router.go(-1)
    },

    /**
     * 发起申请退款
     */
    submitApplicationForRefund() {
      if (this.form.refundReason || this.form.refundReason === 0) {
        this.form.packItems = []
        // 未发货
        this.unshippeds.forEach((item) => {
          if (item.check) {
            this.form.packItems.push({
              kkItemId: item.kkItemId, // 商品ID
              skuCode: item.skuCode, // 公司SKU
              productNum: item.quantity, // 商品数量
              countryCode: item.countryCode, // 商品仓库国家编码
              packId: undefined // 包裹ID(未发货包裹不需要传)
            })
          }
        })
        if (this.form.packItems.length) {
          this.getIsSelectAll()
          this.createAfterSalesOrder() // 发起请求
        } else {
          VanToast.fail('Please select the product to be refunded!')
        }
      } else {
        VanToast.fail('Please Select Refund Reason!')
      }
    },

    /**
     * 判断是否已经是全选
     * 为了设置this.form.selectAllied参数(是否全选(0.未全选 1.全选))
     * 计算方式：item.quantity === item.productNum 则全选
     */
    getIsSelectAll() {
      this.form.selectAllied = 1
      this.unshippeds.forEach((item) => {
        if (item.quantity !== item.productNum) {
          this.form.selectAllied = 0
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  .back {
    color: #7b7b7b;
    font-size: 0.3rem;
    padding: 0.2rem;
    background-color: #fff;
  }

  .record {
    display: flex;
    margin-top: 7px;
    padding: 10px 26px;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    .left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .tips {
        color: #10141d;
        font-size: 15px;
        line-height: 22px;
        margin-bottom: 6px;
      }
      .history {
        color: #99c41c;
        font-size: 15px;
        line-height: 22px;
      }
    }
    .right-icon {
      color: #000000;
      font-size: 16px;
    }
  }

  .reason-remarks {
    margin-top: 7px;
    background-color: #fff;
    .reason {
      display: flex;
      padding: 10px 26px;
      align-items: center;
      justify-content: space-between;
      .tips {
        position: relative;
        color: #b6b6b6;
        font-size: 14px;
        &::after {
          content: '*';
          position: absolute;
          left: -12px;
          top: 2px;
          color: #f56c6c;
        }
        &.active {
          color: #10141d;
        }
      }
      .right-icon {
        color: #000000;
        font-size: 16px;
      }
    }
    .van-cell {
      padding: 10px 26px;
    }
  }

  .goods-list,
  .refunded-details {
    padding: 15px 20px;
    background-color: #fff;
    h3 {
      color: #000;
      font-size: 16px;
      font-weight: 500;
    }
  }

  .goods-list {
    margin: 10px 0;
    .not-data {
      display: flex;
      height: 100%;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      img {
        width: 90%;
      }
      .tips-text {
        color: #747a87;
        font-size: 14px;
        margin-top: 18px;
      }
    }
  }

  .refunded-details {
    margin-bottom: 85px;
    .amount-info {
      .item {
        display: flex;
        padding: 15px 0;
        align-items: center;
        border-bottom: 1px solid #dedede;
        justify-content: space-between;
        .label {
          color: #000;
        }
        .value {
          color: #7b7b7b;
          &.strong {
            color: #10141d;
            font-size: 16px;
            font-weight: 600;
          }
        }
        &.border {
          border: 0;
        }
      }
    }
  }

  .refunded-button {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 8px 15px;
    background-color: #fff;
    box-shadow: 0px 0px 8px 0 rgba(0, 0, 0, 0.12);
    z-index: 9527;
    .van-button {
      height: 44px;
      border-radius: 8px;
    }
  }
}
</style>
